import type { CellKind } from '@shared/game/types';

export const EFFECT_PREVIEW_COPY: Record<CellKind, string> = {
  normal: 'Plataforma de tránsito sin anomalía.',
  start: 'El muelle de salto es una plataforma segura.',
  safe: 'La zona segura bloquea las capturas.',
  shortcut: 'El portal de salto desplaza 3 celdas. No captura ni encadena otra anomalía.',
  risk: 'La fisura devuelve 3 celdas. No captura ni encadena otra anomalía.',
  event: 'El cofre revelará su anomalía al aplicar el movimiento.',
};
